import { ROOT_NAME_SPACE } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const NAME_SPACE = `${ROOT_NAME_SPACE} Configure `;
